<section>
  <aside>

    <div class="container-fluid">

      <!-- UPLOAD STEP -->
      <div id="BulkEditStep1" *ngIf="steps[0]">
        <form>
          <div class="row m-4">
            <div class="form-group">
              <div class="inline-block">
                <label for="uploadBulkEditExcelVBAFile" class="control-label">Excel&reg; file:</label>
                <div id="uploadBulkEditExcelVBAFile" *ngIf="!readingFile"
                     ngfDrop
                     selectable="true"
                     [(validDrag)]="validComboDrag"
                     [(files)]="files"
                     [(file)]="lastFile"
                     [accept]="accept"
                     [maxSize]="maxSize"
                     [(lastInvalids)]="lastInvalids"
                     [(dragFiles)]="dragFiles"
                     class="well my-drop-zone card card-body bg-light"
                     [class.invalid-drag]="validComboDrag===false || dragFiles?.length > 1"
                     [class.valid-drag]="validComboDrag && dragFiles?.length === 1"
                     (filesChange)="comboSelectDragNDropFilesChange($event)"
                     (lastInvalidsChange)="comboSelectDragNDropInvalidFilesChange($event)"
                >
                  Drag and drop or click and select your Excel&reg;	file
                </div>
              </div>
            </div>
          </div>

          <div class="row m-4">

            <div *ngIf="readingFile">
              <div class="card" *ngFor="let item of files;let i=index">
                <div id="selectedBulkEditExcelVBAFile" class="card-header">
                      <span style="margin-right: 10px; float: left;">
                        <i id='bulkEditExcelFileIconWait' class="fas fa-file-excel fa-lg"></i>
                      </span>
                      <span style="float: right">
                        <i class="fa fa-spinner fa-spin fa-lg"></i>
                     </span>
                  <h5 class="card-title"> Reading file... </h5>
                </div>
              </div>
            </div>

            <div *ngIf="!readingFile">
              <div class="card" *ngFor="let item of files;let i=index">
                <div id="readingBulkEditExcelVBAFile" class="card-header">
                    <span style="margin-right: 10px; float: left;">
                      <i id='bulkEditExcelFileIcon' class="fas fa-file-excel"></i>
                    </span>
                    <span style="float: right">
                      <a [id]="'uploadBulkEditExcelVBAFile_' + item.name"
                         (click)="uploadBulkEditExcelVBAFile( item )"
                         class="fas fa-upload"
                         tooltip="Upload selected file"
                         title="Upload selected file"
                         style="margin-right: 1em"></a>
                      <a [id]="'removeBulkEditExcelVBAFile_' + item.name"
                         (click)="removeFileAt(i)"
                         class="fas fa-trash" tooltip="Remove selected file"
                         title="Remove selected file"></a>
                    </span>
                  <h5 class="card-title" style="max-width: calc(100% - 5em)">
                    <small>[{{ item.size / 1024 / 1024 | number:'.2' }} MB]</small>
                    {{item.name}}
                  </h5>
                </div>
              </div>

            </div>
          </div>
          <div class="form-row"></div>
        </form>
      </div>
    </div>
    <!-- END UPLOAD STEP -->

    <!-- SUMMARY STEP -->
    <div id="BulkEditStep2" *ngIf="steps[1]">
      <div class="card">
        <div id="bulkEditSummaryHeader" class="card-header">Changes summary</div>
        <div id="bulkEditSummaryBody" class="card-body">
          <div class="card card-secondary">
            <div class="row" style="padding-bottom: 2ex;">

              <div class="col-md-4 col-xs-4">
                <div id="bulkEditParsedLocale" class="bulk-edit-summary-item-panel" style="display: block;">
                  <h2 class="bulk-edit-summary-item-header" style="display: block;"
                      [innerHTML]="bulkEditSession?.locale?.displayLabels?.en_US"></h2>
                  <div class="bulk-edit-summary-item-label" style="display: block;">
                    <span [class]="' badge-label locale-label ' + bulkEditSession?.locale?.localeName"
                          [innerHTML]="bulkEditSession?.locale?.localeName"
                          [tooltip]="bulkEditSession?.locale?.displayLabels?.en_US"></span>
                  </div>
                </div>
                <div id="bulkEditParsedProgram" class="bulk-edit-summary-item-panel" style="display: block;">
                  <h2 class="bulk-edit-summary-item-header" style="display: block;"
                      [innerHTML]="bulkEditSession.product.displayLabel"></h2>
                  <div class="bulk-edit-summary-item-label" style="display: block;">
                    <span
                      [class]="'badge-label program-label ' + (bulkEditSession?.product?.id ? bulkEditSession.product.displayLabel : 'DEFAULT')"
                      [innerHTML]="bulkEditSession.product.displayLabel"
                      [tooltip]="getOperatorProgramProductDisplayLabel(bulkEditSession.product)"></span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 col-xs-8">
                <div id="bulkEditParsedFilename" class="col-md-12 col-xs-12 bulk-edit-summary-item-panel">
                  <h2 class="bulk-edit-summary-item-header" style="display: block;">Filename</h2>
                  <span class="bulk-edit-summary-item-label" style="display: block;">
                      <i class="fas fa-file-excel"></i>&nbsp;{{bulkEditSession?.file.name}}
                  </span>
                </div>
                <div id="bulkEditParsedDate" class="col-md-12 col-xs-12 bulk-edit-summary-item-panel">
                  <h2 class="bulk-edit-summary-item-header" style="display: block;">File creation Date</h2>
                  <span class="bulk-edit-summary-item-label" style="display: block;"
                        [innerHTML]="bulkEditSession?.generationDate"></span>
                </div>
              </div>
            </div>
          </div>

          <div *ngFor="let changeType of bulkEditSession?.getChangeTypes()"
               [class]="'col-md-3 col-xs-3 bulk-edit-summary-item-panel ' + changeType">
            <span [id]="'bulkEditSummaryItemHeader_' + changeType"
                  [class]="'bulk-edit-summary-item-header ' + changeType"
                  [innerHTML]="changeTypeSummaryText(changeType)"></span>
            <span [id]="'bulkEditSummaryItemCount_' + changeType" [class]="'bulk-edit-summary-item-body ' + changeType"
                  [innerHTML]="bulkEditSession?.changes.get(changeType).length"></span>
          </div>

        </div>
      </div>

      <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-3">

          <button id="backToStep1" class="col-md-3 col-md-offset-6 text-right btn btn-default btn-sm"
                  type="button"
                  [disabled]="false" (click)="goToPreviousStep()"
                  title="Choose a different file">Choose a different file
          </button>
          <button id="goToStep3" class="col-md-3 col-md-offset-6 text-right btn btn-primary btn-sm"
                  type="button"
                  [disabled]="(bulkEditSession?.getChangeTypes() | relevantBulkEditChangesFilter: bulkEditSession).length < 1"
                  (click)="goToNextStep()"
                  title="Check changes"
                  [innerHTML]="(bulkEditSession?.getChangeTypes() | relevantBulkEditChangesFilter: bulkEditSession).length < 1?
                                'No changes, choose a different file' :
                                'Check changes'"></button>
        <div class="row"><br/></div>
      </div>
    </div>
    <!-- END SUMMARY STEP -->

    <!-- CHECK STEP -->
    <div id="BulkEditStep3" *ngIf="steps[2]">
      <div [class]="'card ' + changeType"
           *ngFor="let changeType of bulkEditSession?.getChangeTypes() | relevantBulkEditChangesFilter: bulkEditSession">
        <div [id]="'bulkEditCheckHeader_' + changeType" [class]="'card-header ' + changeType"
             [innerHTML]="changeType"></div>
        <div [id]="'bulkEditCheckBody_' + changeType" [class]="'card-body ' + changeType">


          <div class="container-fluid" *ngFor="let ber of bulkEditSession.changes.get(changeType); let i=index">
            <app-bulk-edit-change-diff
              [localeSel]="this.localeSel"
              [productSel]="this.productSel"
              [locales]="this.locales"
              [products]="this.products"
              [record]="ber"
              [index]="i"
              (checkBreakTagCondition)="checkBreakTag($event)"
              >
            </app-bulk-edit-change-diff>
              
          </div>

        </div>
      </div>
      <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-3">
        <div class="col-md-3 col-md-offset-6 text-right">
          <button id="backToStep2" class="btn btn-default btn-sm btn-block w-100"
                  type="button"
                  [disabled]="false" (click)="goToPreviousStep()"
                  title="Return to summary">Return to summary
          </button>
        </div>
        <div class="col-md-3 text-right">
          <button id="goToStep4" class="btn btn-primary btn-sm btn-block w-100"
                  type="button"
                  [disabled]="breakTag" (click)="saveBulkEditModal.show()"
                  title="Save changes">Save changes
          </button>
        </div>
      </div>
      <div class="row"><br/></div>
    </div>
    <!-- END CHECK STEP -->
  </aside>
</section>

<section>
  <aside>
    <!-- Alert Modal -->
    <div class="modal fade" bsModal #alertModal="bs-modal" [config]="{backdrop: 'static'}"
         tabindex="-1" role="dialog" aria-labelledby="alertModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="alertModalLabel">Alert</h4>
            <button id="alertModalHeaderClose" type="button" class="btn-close btn-close-white" data-dismiss="modal" aria-label="Close"
                    (click)="alertModal.hide()"></button>
          </div>
          <div class="modal-body">
            <h3>{{alertTitle}}</h3>
              <div class="row padding-bottom-lg padding-top-lg" style="overflow-y: scroll; max-height: calc(100vh - 350px);">
                <div style="max-width: 98%">
                  <ul>
                    <li *ngFor="let m of alertMessages">
                      <strong>{{m.title}}:&nbsp;</strong>{{m.description}}
                    </li>
                  </ul>
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button id="alertModalFooterCancel" type="button" class="btn btn-primary btn-sm btn-block w-100"
                        data-dismiss="modal" (click)="alertModal.hide(); resetAlertMessages();" title="OK">OK
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Alert Modal -->

    <!-- Confirm Save Modal -->
    <div class="modal fade" bsModal #saveBulkEditModal="bs-modal" [config]="{backdrop: 'static'}"
         tabindex="-1" role="dialog" aria-labelledby="saveBulkEditModal">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="saveBulkEditModalLabel">Confirm</h4>
            <button id="saveBulkEditModalHeaderClose" type="button" class="btn-close btn-close-white" data-dismiss="modal"
                    aria-label="Close" (click)="saveBulkEditModal.hide()">
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row text-primary">WARNING: You are about to perform the following changes:</div>
              <div class="row">
                <div
                  *ngFor="let changeType of bulkEditSession?.getChangeTypes() | relevantBulkEditChangesFilter: bulkEditSession : true"
                  [class]="'col-md-4 col-xs-4 bulk-edit-summary-item-panel ' + changeType">
                  <span [id]="'bulkEditConfirmItemHeader_' + changeType"
                        [class]="'bulk-edit-summary-item-header ' + changeType"
                        [innerHTML]="changeTypeSummaryText(changeType)"></span>
                  <span [id]="'bulkEditConfirmItemCount_' + changeType"
                        [class]="'bulk-edit-summary-item-body ' + changeType"
                        [innerHTML]="bulkEditSession?.changes.get(changeType).length"></span>
                </div>
              </div>
              <div class="row text-primary">Are you sure you want to proceed and save these changes?</div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button id="saveBulkEditModalFooterAccept" type="button" class="btn btn-primary btn-sm btn-block w-100"
                        data-dismiss="modal" (click)="saveChanges();saveBulkEditModal.hide()">OK
                </button>
                <button id="saveBulkEditModalFooterCancel" type="button" class="btn btn-default btn-sm btn-block w-100"
                        data-dismiss="modal" (click)="saveBulkEditModal.hide()">Cancel
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Confirm Save Modal -->

    <!-- Save Report Modal -->
    <div class="modal fade" bsModal #reportBulkEditModal="bs-modal" [config]="{backdrop: 'static'}"
         tabindex="-1" role="dialog" aria-labelledby="reportBulkEditModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="reportBulkEditModalLabel">Report</h4>
            <button id="reportBulkEditModalHeaderClose" type="button" class="btn-close btn-close-white" data-dismiss="modal"
              aria-label="Close" (click)="reportBulkEditModal.hide()">
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div
                *ngIf="uploadingProgress.responseCount < uploadingProgress.requestsCount ||
                       (uploadingProgress.responseCount > 0 &&
                                       uploadingProgress.responseCount === uploadingProgress.requestsCount)">
                <span class="padding-bottom-md"> Performing changes, please wait...</span>
                <div class="progress">
                  <div *ngFor="let res of uploadingProgress.responses"
                       [class]="(res === undefined ? '' : 'progress-bar progress-bar-' + (res ? 'success' : 'danger')) "
                       [style.width.%]="(100/uploadingProgress.requestsCount)">
                  </div>
                </div>
                <span>Record {{uploadingProgress.responseCount}} of {{uploadingProgress.requestsCount}}</span>
              </div>
              <div *ngIf="uploadingProgress.responseCount >= uploadingProgress.requestsCount">
                <!-- success report-->
                <div *ngIf="!bulkEditSession?.hasResultErrors()" class="padding-md bg-success text-white round-border">
                  <i class="fas fa-info-circle fa-lg" style="color: #59BC5F"></i>
                  &nbsp;
                  All of the changes were successfully performed
                </div>
                <!-- END success report-->
                <!--  error report-->
                <div *ngIf="bulkEditSession?.hasResultErrors()">
                  <div class="row padding-md bg-danger round-border">
                    <span style="vertical-align: middle">
                      <i class="fas fa-exclamation-circle fa-lg" style="color: #B0003A"></i>
                      &nbsp;The following changes weren't performed for:&nbsp;
                    </span>
                    <span id="errorReportLocale"
                          [class]="'badge-label locale-label ' + (bulkEditSession.locale.localeName)"
                          [tooltip]="bulkEditSession?.locale?.displayLabels?.en_US"
                          [innerHTML]="bulkEditSession?.locale?.localeName"></span>&nbsp;
                    <span id="errorReportProgram"
                          [class]="'badge-label product-label ' + (bulkEditSession.product.displayLabel)"
                          [tooltip]="bulkEditSession?.product?.displayLabel"
                          [innerHTML]="bulkEditSession?.product?.displayLabel || 'DEFAULT'"></span>
                  </div>
                  <!-- Error list -->
                  <div class="row padding-bottom-lg" style="overflow-y: scroll; max-height: calc(100vh - 350px);">
                    <table>
                      <thead>
                      <tr>
                        <td class="bg-enelx" style="text-align: center;"><h3>Action</h3></td>
                        <td class="bg-enelx" style="text-align: center;"><h3>Delivery Path</h3></td>
                        <td class="bg-enelx" style="text-align: center;"><h3>Component name</h3></td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let errResult of bulkEditSession?.getResultErrors(); index as i">
                        <td class="padding-top-sm col-md-2 col-xs-2">
                        <span [id]="'errorAction_'  + i"
                              [class]="'badge-label delivery-path-label ' + (errResult.bulkEditRecord.type)"
                              [innerHTML]="errResult.bulkEditRecord.type"></span>
                        </td>
                        <td class="padding-top-sm col-md-2 col-xs-2">
                        <span [id]="'errorReportDeliveryPath_'  + i"
                              [class]="'badge-label delivery-path-label ' + (errResult.bulkEditRecord.currentComponent.deliveryPath.code)"
                              [innerHTML]="errResult.bulkEditRecord.currentComponent.deliveryPath.code"></span>
                        </td>
                        <td class="padding-top-sm col-md-8 col-xs-8"
                            style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; ">
                        <span [id]="'errorComponentName_' + i"
                              [innerHTML]="errResult.bulkEditRecord.currentComponent.name"></span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- END Error list -->
                </div>
                <!-- END error report-->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button id="reportBulkEditModalFooterAccept" type="button" class="btn btn-primary btn-sm btn-block w-100"
                        data-dismiss="modal" (click)="endBulkEditSession(); reportBulkEditModal.hide()">OK
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Save Report Modal -->
  </aside>
</section>
